import { render } from "./ModalFileUploadCategory.vue?vue&type=template&id=01d08e26&scoped=true"
import script from "./ModalFileUploadCategory.vue?vue&type=script&lang=js"
export * from "./ModalFileUploadCategory.vue?vue&type=script&lang=js"

import "./ModalFileUploadCategory.vue?vue&type=style&index=0&id=01d08e26&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d08e26"]])

export default __exports__